/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ActivationUpdateDTO } from '../model/activationUpdateDTO';
import { AllVasServiceResponseDto } from '../model/allVasServiceResponseDto';
import { CreateVasServiceDto } from '../model/createVasServiceDto';
import { ProblemDetails } from '../model/problemDetails';
import { SMSSubscriptionDto } from '../model/sMSSubscriptionDto';
import { StandardResponseDTO } from '../model/standardResponseDTO';
import { VasResponseData } from '../model/vasResponseData';
import { VasServiceModel } from '../model/vasServiceModel';
import { VasServiceModelPaginatedResponse } from '../model/vasServiceModelPaginatedResponse';
import { VasServiceResponseDto } from '../model/vasServiceResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VasServiceService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceCreateVasServicePost(body?: CreateVasServiceDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiVasServiceCreateVasServicePost(body?: CreateVasServiceDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiVasServiceCreateVasServicePost(body?: CreateVasServiceDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiVasServiceCreateVasServicePost(body?: CreateVasServiceDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/VasService/CreateVasService`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceDeleteVasServiceVasServiceIdDelete(vasServiceId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceResponseDto>;
    public apiVasServiceDeleteVasServiceVasServiceIdDelete(vasServiceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceResponseDto>>;
    public apiVasServiceDeleteVasServiceVasServiceIdDelete(vasServiceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceResponseDto>>;
    public apiVasServiceDeleteVasServiceVasServiceIdDelete(vasServiceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceDeleteVasServiceVasServiceIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceResponseDto>('delete',`${this.basePath}/api/VasService/DeleteVasService/${encodeURIComponent(String(vasServiceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param serviceProviderId 
     * @param shortCode 
     * @param keyword 
     * @param keyNumber 
     * @param page 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceGetAllVasServiceGet(serviceId?: string, serviceProviderId?: string, shortCode?: string, keyword?: string, keyNumber?: string, page?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<AllVasServiceResponseDto>;
    public apiVasServiceGetAllVasServiceGet(serviceId?: string, serviceProviderId?: string, shortCode?: string, keyword?: string, keyNumber?: string, page?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllVasServiceResponseDto>>;
    public apiVasServiceGetAllVasServiceGet(serviceId?: string, serviceProviderId?: string, shortCode?: string, keyword?: string, keyNumber?: string, page?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllVasServiceResponseDto>>;
    public apiVasServiceGetAllVasServiceGet(serviceId?: string, serviceProviderId?: string, shortCode?: string, keyword?: string, keyNumber?: string, page?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('ServiceId', <any>serviceId);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('ShortCode', <any>shortCode);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('Keyword', <any>keyword);
        }
        if (keyNumber !== undefined && keyNumber !== null) {
            queryParameters = queryParameters.set('KeyNumber', <any>keyNumber);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('Page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllVasServiceResponseDto>('get',`${this.basePath}/api/VasService/GetAllVasService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param keyNumber 
     * @param shortCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceGetServiceByShortCodeAndKeyNumberGet(keyNumber?: string, shortCode?: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceModel>;
    public apiVasServiceGetServiceByShortCodeAndKeyNumberGet(keyNumber?: string, shortCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceModel>>;
    public apiVasServiceGetServiceByShortCodeAndKeyNumberGet(keyNumber?: string, shortCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceModel>>;
    public apiVasServiceGetServiceByShortCodeAndKeyNumberGet(keyNumber?: string, shortCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (keyNumber !== undefined && keyNumber !== null) {
            queryParameters = queryParameters.set('keyNumber', <any>keyNumber);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceModel>('get',`${this.basePath}/api/VasService/getServiceByShortCodeAndKeyNumber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param keyword 
     * @param shortCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceGetServiceByShortCodeAndKeywordGet(keyword?: string, shortCode?: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceModel>;
    public apiVasServiceGetServiceByShortCodeAndKeywordGet(keyword?: string, shortCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceModel>>;
    public apiVasServiceGetServiceByShortCodeAndKeywordGet(keyword?: string, shortCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceModel>>;
    public apiVasServiceGetServiceByShortCodeAndKeywordGet(keyword?: string, shortCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceModel>('get',`${this.basePath}/api/VasService/getServiceByShortCodeAndKeyword`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCode 
     * @param keyword 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceGetVasServiceByShortCodeAndKeyWordGet(shortCode?: string, keyword?: string, observe?: 'body', reportProgress?: boolean): Observable<VasResponseData>;
    public apiVasServiceGetVasServiceByShortCodeAndKeyWordGet(shortCode?: string, keyword?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasResponseData>>;
    public apiVasServiceGetVasServiceByShortCodeAndKeyWordGet(shortCode?: string, keyword?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasResponseData>>;
    public apiVasServiceGetVasServiceByShortCodeAndKeyWordGet(shortCode?: string, keyword?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasResponseData>('get',`${this.basePath}/api/VasService/GetVasServiceByShortCodeAndKeyWord`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceGetVasServiceBySpIdSpIdGet(spId: string, observe?: 'body', reportProgress?: boolean): Observable<AllVasServiceResponseDto>;
    public apiVasServiceGetVasServiceBySpIdSpIdGet(spId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllVasServiceResponseDto>>;
    public apiVasServiceGetVasServiceBySpIdSpIdGet(spId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllVasServiceResponseDto>>;
    public apiVasServiceGetVasServiceBySpIdSpIdGet(spId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (spId === null || spId === undefined) {
            throw new Error('Required parameter spId was null or undefined when calling apiVasServiceGetVasServiceBySpIdSpIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllVasServiceResponseDto>('get',`${this.basePath}/api/VasService/GetVasServiceBySpId/${encodeURIComponent(String(spId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasServiceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceGetVasServiceByVasServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'body', reportProgress?: boolean): Observable<VasServiceResponseDto>;
    public apiVasServiceGetVasServiceByVasServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceResponseDto>>;
    public apiVasServiceGetVasServiceByVasServiceIdVasServiceIdGet(vasServiceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceResponseDto>>;
    public apiVasServiceGetVasServiceByVasServiceIdVasServiceIdGet(vasServiceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (vasServiceId === null || vasServiceId === undefined) {
            throw new Error('Required parameter vasServiceId was null or undefined when calling apiVasServiceGetVasServiceByVasServiceIdVasServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceResponseDto>('get',`${this.basePath}/api/VasService/GetVasServiceByVasServiceId/${encodeURIComponent(String(vasServiceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param draw 
     * @param search 
     * @param serviceId 
     * @param serviceProviderId 
     * @param shortCode 
     * @param keyword 
     * @param keyNumber 
     * @param page 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceGetservicesGet(draw?: number, search?: string, serviceId?: string, serviceProviderId?: string, shortCode?: string, keyword?: string, keyNumber?: string, page?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<VasServiceModelPaginatedResponse>;
    public apiVasServiceGetservicesGet(draw?: number, search?: string, serviceId?: string, serviceProviderId?: string, shortCode?: string, keyword?: string, keyNumber?: string, page?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceModelPaginatedResponse>>;
    public apiVasServiceGetservicesGet(draw?: number, search?: string, serviceId?: string, serviceProviderId?: string, shortCode?: string, keyword?: string, keyNumber?: string, page?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceModelPaginatedResponse>>;
    public apiVasServiceGetservicesGet(draw?: number, search?: string, serviceId?: string, serviceProviderId?: string, shortCode?: string, keyword?: string, keyNumber?: string, page?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (draw !== undefined && draw !== null) {
            queryParameters = queryParameters.set('draw', <any>draw);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('ServiceId', <any>serviceId);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('ShortCode', <any>shortCode);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('Keyword', <any>keyword);
        }
        if (keyNumber !== undefined && keyNumber !== null) {
            queryParameters = queryParameters.set('KeyNumber', <any>keyNumber);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('Page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceModelPaginatedResponse>('get',`${this.basePath}/api/VasService/getservices`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param keyword 
     * @param unsubscriptionKeyword 
     * @param shortCodeKeyNumber 
     * @param serviceName 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceServiceDetailsGet(keyword?: string, unsubscriptionKeyword?: string, shortCodeKeyNumber?: string, serviceName?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<VasServiceModel>;
    public apiVasServiceServiceDetailsGet(keyword?: string, unsubscriptionKeyword?: string, shortCodeKeyNumber?: string, serviceName?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VasServiceModel>>;
    public apiVasServiceServiceDetailsGet(keyword?: string, unsubscriptionKeyword?: string, shortCodeKeyNumber?: string, serviceName?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VasServiceModel>>;
    public apiVasServiceServiceDetailsGet(keyword?: string, unsubscriptionKeyword?: string, shortCodeKeyNumber?: string, serviceName?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }
        if (unsubscriptionKeyword !== undefined && unsubscriptionKeyword !== null) {
            queryParameters = queryParameters.set('unsubscriptionKeyword', <any>unsubscriptionKeyword);
        }
        if (shortCodeKeyNumber !== undefined && shortCodeKeyNumber !== null) {
            queryParameters = queryParameters.set('shortCodeKeyNumber', <any>shortCodeKeyNumber);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VasServiceModel>('get',`${this.basePath}/api/VasService/serviceDetails`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param keyword 
     * @param shortCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceSmsSubscriptionGet(keyword?: string, shortCode?: string, observe?: 'body', reportProgress?: boolean): Observable<SMSSubscriptionDto>;
    public apiVasServiceSmsSubscriptionGet(keyword?: string, shortCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SMSSubscriptionDto>>;
    public apiVasServiceSmsSubscriptionGet(keyword?: string, shortCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SMSSubscriptionDto>>;
    public apiVasServiceSmsSubscriptionGet(keyword?: string, shortCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SMSSubscriptionDto>('get',`${this.basePath}/api/VasService/smsSubscription`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiVasServiceUpdateActivationStatusPost(body?: ActivationUpdateDTO, observe?: 'body', reportProgress?: boolean): Observable<StandardResponseDTO>;
    public apiVasServiceUpdateActivationStatusPost(body?: ActivationUpdateDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StandardResponseDTO>>;
    public apiVasServiceUpdateActivationStatusPost(body?: ActivationUpdateDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StandardResponseDTO>>;
    public apiVasServiceUpdateActivationStatusPost(body?: ActivationUpdateDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<StandardResponseDTO>('post',`${this.basePath}/api/VasService/UpdateActivationStatus`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
